import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import Breadcrumb from '../components/Breadcrumb';
import { Link } from 'react-router-dom';
import '../styles/Dashboard.css';
import ModalCambios from '../components/ModalCambios';

// Iconos SVG simples para no depender de librerías externas
const Icons = {
  Users: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
  ),
  Dollar: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
  ),
  Shield: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
  ),
  Calendar: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
  ),
  Arrow: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
  ),
  Filter: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12 10 19 14 21 14 12 22 3" /></svg>
  )
};

export default function Dashboard() {
  const { roles } = useContext(AuthContext);
  const [mostrarModalCambios, setMostrarModalCambios] = useState(false);
  const isAdminOrOdonto = roles.includes('ADMIN') || roles.includes('ODONTOLOGO');
  const isAdmin = roles.includes('ADMIN');

  const cerrarModalCambios = async () => {
    await axios.post("/api/app/version-seen", {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    setMostrarModalCambios(false);
  };

  useEffect(() => {
    axios.get("/api/app/version-status", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(res => {
      if (res.data.showChanges) {
        setMostrarModalCambios(true);
      }
    });
  }, []);

  return (
    <>
      {mostrarModalCambios && (
        <ModalCambios onClose={cerrarModalCambios} />
      )}
      <div className="dashboard">
        <div className="dashboard-container">
          <Breadcrumb />
          <div className="dashboard-header">
            <h1>Panel de Control</h1>
            <p className="subtitle">Bienvenido</p>
          </div>          
          <div className="widget-grid">
            {/* Widget Pacientes */}
            <Link to="/pacientes" className="widget card-blue">
              <div className="widget-icon">
                <Icons.Users />
              </div>
              <div className="widget-content">
                <h3>Pacientes</h3>
                <p>Registro, tratamientos y presupuestos</p>
              </div>
              <div className="widget-action">
                <Icons.Arrow />
              </div>
            </Link>

            {/* Widget Calendario */}
            <Link to="/calendario" className="widget card-purple">
               <div className="widget-icon">
                 <Icons.Calendar />
               </div>
               <div className="widget-content">
                 <h3>Calendario</h3>
                 <p>Organización de agenda semanal</p>
               </div>
               <div className="widget-action">
                 <Icons.Arrow />
               </div>
            </Link>

            {/* Widget Facturación */}
            {isAdminOrOdonto && (
              <Link to="/facturacion/general" className="widget card-green">
                <div className="widget-icon">
                  <Icons.Dollar />
                </div>
                <div className="widget-content">
                  <h3>Facturación</h3>
                  <p>Gestión de cobros y reportes</p>
                </div>
                <div className="widget-action">
                   <Icons.Arrow />
                </div>
              </Link>
            )}
            {/* Widget Tratamientos */}
            <Link to="/tratamientos" className="widget card-teal">
              <div className="widget-icon">
                <Icons.Filter />
              </div>
              <div className="widget-content">
                <h3>Tratamientos</h3>
                <p>Catálogo de tratamientos y precios</p>
                <span className="badge badge-info">Solo alta</span>
              </div>
              <div className="widget-action">
                <Icons.Arrow />
              </div>
            </Link>
            <Link to="/recalls" className="widget card-yellow">
              <div className="widget-icon">
                <Icons.Calendar />
              </div>
              <div className="widget-content">
                <h3>Recalls</h3>
                <p>Recordatorio de citas</p>
              </div>
              <div className="widget-action">
                <Icons.Arrow />
              </div>
            </Link>
            {/* Widget Auditoría */}
            {isAdminOrOdonto && (
              <Link to="/auditoria" className="widget card-orange">
                <div className="widget-icon">
                  <Icons.Shield />
                </div>
                <div className="widget-content">
                  <h3>Auditoría</h3>
                  <p>Logs de seguridad y accesos</p>
                </div>
                <div className="widget-action">
                  <Icons.Arrow />
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
}